var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map-wrap"},[_c('yandex-map',{staticStyle:{"width":"100%","height":"520px"},attrs:{"coords":_vm.coords,"zoom":_vm.zoom,"controls":_vm.controls,"scroll-zoom":false,"map-type":"map"},on:{"click":_vm.setEvent}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }